import ImgixClient from "@imgix/js-core";
import type { ImageLoaderProps } from "next/image";

const imgixClient = new ImgixClient({
  domain: "i.fndm.to",
  secureURLToken: process.env.IMGIX_SECRET_TOKEN || "",
  includeLibraryParam: false,
  useHTTPS: true,
});

export default function imgixLoader({ src, width, quality }: ImageLoaderProps) {
  if (!src.includes("s.fndm.to")) {
    return src;
  }
  return imgixClient.buildURL(src, {
    width,
    quality,
    auto: ["format"],
  });
}
